/* eslint semi:0 */
import React from 'react'
import { noop, } from 'utils/fn'
import ShareButton from './shareButton'
import { isDesktop, } from 'utils/ua'
import { socialBarActions, } from '../socialBarActions'


const BLOCK_NAME = 'share-buttons'

function shareButton(props){
  return <ShareButton { ...props } />
}

function shareButtonListItem(attrs, key){
  const shareButtonProps = {
    ...attrs,
    blockName: BLOCK_NAME,
    triggerAnalyticsFluxAction: socialBarActions.socialShare(attrs.title),
  }
  const listItemProps = {
    key,
    className: `${ BLOCK_NAME }__share-button-item`,
    children: shareButton(shareButtonProps),
  }
  return <li { ...listItemProps }/>
}

function getShareButtonsViews(shareButtons){
  return shareButtons.map(shareButtonListItem)
}

export default class ShareButtonsComponent extends React.Component {

  handleTouchStart(checkboxChecked, e) {
    e.preventDefault()
  }

  render(){
    const { shareButtons, checkboxChecked, toggleCheckbox } = this.props
    const labelProps = {
      className: BLOCK_NAME,
      onTouchStart: checkboxChecked ? this.handleTouchStart.part(checkboxChecked) : toggleCheckbox,
      style: checkboxChecked ? { pointerEvents: 'none', } : {},
    }
    return (
      <label { ...labelProps }>
        <input
          hidden
          type='checkbox'
          autoComplete='off'
          checked={ checkboxChecked }
          name={ `${ BLOCK_NAME }-toggle` }
          className={ `${ BLOCK_NAME }__checkbox` }
          onChange={ isDesktop ? toggleCheckbox : noop }
        />
        <ul className={ `${ BLOCK_NAME }__buttons-list` }>
          { getShareButtonsViews(shareButtons) }
        </ul>
      </label>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/components/shareButtonsComponent.js